<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import "@/compiled-icons";
export default {
  name: "App",
  beforeCreate() {
    if (this.$route.params.lang) {
      this.$ml.change(this.$route.params.lang);
    }
  },
  watch: {
    $route(to) {
      this.$ml.change(to.params.lang);
    }
  }
};
</script>
<style lang="scss">
// GLOBAL
body {
  margin: 0;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  background: $ui-gray-2;
}
#app {
  overflow: hidden;
  *,
  ::before,
  ::after {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-tap-highlight-color: transparent;
  }
}
</style>
